import React from 'react';
import { ArrowLeft, LogOut } from 'lucide-react';

function AdminDashboardHeader({
  canReturnToSuperAdmin,
  onLogout,
  onOpenSetupCard,
  onReturnToSuperAdmin,
  setupProgress,
  user
}) {
  return (
    <>
      {canReturnToSuperAdmin && (
        <div className="impersonation-chip-row">
          <span className="impersonation-chip-label">Impersonating this company</span>
          <button type="button" className="impersonation-chip-action" onClick={onReturnToSuperAdmin}>
            <ArrowLeft className="btn-icon" size={14} />
            <span>Return to Super Admin</span>
          </button>
        </div>
      )}
      <header className="dashboard-header">
        <div className="dashboard-header-main">
          <h1>Operations Console</h1>
          <p className="dashboard-header-subtitle">Inventory, orders, and access control</p>
        </div>
        <div className="user-info">
          <span className="header-welcome-pill">
            {user.username === 'admin' && user.real_name
              ? `Welcome back, ${user.real_name}`
              : `Welcome back, ${user.username}`}
          </span>
          {typeof onOpenSetupCard === 'function' && setupProgress ? (
            <button type="button" className="header-setup-btn" onClick={onOpenSetupCard}>
              Checklist {setupProgress}
            </button>
          ) : null}
          <button
            type="button"
            onClick={onLogout}
            className="logout-btn"
            aria-label="Log out"
            title="Log out"
          >
            <LogOut className="btn-icon" size={16} />
            <span>Log out</span>
          </button>
        </div>
      </header>
    </>
  );
}

export default AdminDashboardHeader;
